import { makeStyles } from "@material-ui/core/styles";
import Instagram from "@material-ui/icons/Instagram";

const useStyles = makeStyles(({ breakpoints, mixins, spacing }) => ({
  footerContainer: {
    marginBottom: "4%",
  },
  footer: {
    backgroundColor: "#E6E2FE",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "auto auto",
    padding: "5% 6% 3% 6%",
    borderRadius: "5px",
  },
  footerBoxOne: {
    display: "grid",
    gridTemplateRows: "auto auto",
    gridTemplateColumns: "60%",
    justifyItems: "center",
    marginBottom: "5%",
  },
  logo: {
    width: "90%",
    margin: "5%",
  },
  description: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "23px",
  },
  footerBoxTwo: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "1fr 1fr",
    alignSelf: "center",
  },
  link: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    textTransform: "none!important",
    textDecoration: "none !important",
    "&:hover": {
      background: "none",
    },
  },
  footerBoxThree: {
    display: "grid",
    gridTemplateColumns: "60%",
    gridTemplateRows: "auto auto",
  },
  instagram: {
    color: "#5B3483",
  },
  facebook: {
    color: "#5B3483",
  },
  terms: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#5B3483",
  },
  footerBoxFour: {
    justifySelf: "end",
    alignSelf: "center",
  },
  website: {
    color: "#5B3483",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "23px",
  },
  active: {
    color: "#8BC7B5 !important",
  },
  activeLink: {
    textDecoration: "none !important",
  },
}));

export default useStyles;
// footerBoxOne: {
//     display: "grid",
//     gridTemplateRows: "repeat(4, auto)",
// },
// description: {
//     fontWeight: 300,
//     fontSize: "18px",
//     lineHeight: "23px",
//     width: "50%"
// },
